import { CategoryManagementSOList } from "../../../constants/filter.constants";
import SuccessSignIcon from "../../icons/success-sign.icon";

const SortOrderListMenu = ({ sortOrderList = [], onDefineOrder = () => {}, onOrderChange = () => {}, selectedOrder = null }) => {
  const handleDefineOrder = (item) => {
    onDefineOrder(item);
    document.body.click();
  }
  const handleOrderChange = (item) => {
    onOrderChange(item);
    document.body.click();
  }
  return (
    <div className="d-flex flex-column gap-2 no-wrap">
      <div className="f-12 line-height-18 f-400 f-darkgrey" style={{ padding: '4px 16px' }}>Order</div>
      {sortOrderList.map((item) => (
        <div 
          key={item.value} 
          className="d-flex align-items-center justify-content-between gap-2 item"
          onClick={() => handleOrderChange(item)}
        >
          <span className="f-14 line-height-22 f-400 f-grey">
            {item.label}
          </span>
          {selectedOrder?.value === item.value && (
             <SuccessSignIcon className="fill-current f-grey" />
          )}
        </div>
      ))}
      <div className="separator" />
      {CategoryManagementSOList.map((item) => (
        <div 
          key={item.value} 
          className="d-flex align-items-center gap-2 item"
          onClick={() => handleDefineOrder(item)}
        >
          <span className="f-14 line-height-22 f-400 f-grey">
            {item.label}
          </span>
        </div>
      ))}
    </div>
  )
}

export default SortOrderListMenu;
